import React from 'react';
import PropTypes from 'prop-types';
import Logo from './Logo';
import EmptyState from './EmptyState';
import Grid from './Grid';
import CustomButtons from './CustomButtons';
import styles from '../css/app.css';
import { getSafeImageUrl } from '../utils';

const DEFAULT_COLOR = '#000000';
const DEFAULT_CONTRAST_COLOR = '#ffffff';

const App = ({
  logoSrc,
  accountName,
  posts,
  links,
}) => {
  const hasAtLeastOnePostWithLink = posts && posts.some(post => post.link);
  const hasCustomLinks = links && links.custom_links && links.custom_links.length > 0
    && Object.keys(links.custom_links[0]).length > 0;
  const hasEmptyGrid = !hasAtLeastOnePostWithLink && !hasCustomLinks;

  if (hasEmptyGrid) {
    return (<EmptyState />);
  }

  return (
    <div className={styles.app}>
      <Logo
        logoSrc={getSafeImageUrl(logoSrc)}
        accountName={accountName}
      />
      {hasCustomLinks
        && (
          <CustomButtons
            links={links}
            buttonColor={links.custom_links_color || DEFAULT_COLOR}
            textColor={links.custom_links_contrast_color || DEFAULT_CONTRAST_COLOR}
          />
        )
      }
      { posts && posts.length > 0 && hasAtLeastOnePostWithLink
        && (
          <span>
            <p className={styles.explanation}>Tap image to view link</p>
            <Grid
              posts={posts}
            />
          </span>
        )
      }
    </div>
  );
};

App.propTypes = {
  logoSrc: PropTypes.string.isRequired,
  accountName: PropTypes.string.isRequired,
  posts: PropTypes.arrayOf(
    PropTypes.shape({
      thumbnail: PropTypes.string.isRequired,
      imageAlt: PropTypes.string,
      link: PropTypes.string,
      id: PropTypes.string.isRequired,
    }),
  ).isRequired,
  links: PropTypes.shape({
    custom_links_color: PropTypes.string,
    custom_links_contrast_color: PropTypes.string,
    custom_links: PropTypes.array,
  }),
};

App.defaultProps = {
  links: {},
};

export default App;



/** WEBPACK FOOTER **
 ** ./app/webroot/js/instagramBioGrid/components/App.jsx
 **/